/* eslint-disable import/no-named-as-default */
import React, { FunctionComponent } from "react";
import { Provider } from "react-redux";
import store from "../../store";
import HowToGuides from "./HowToGuides";

const ProviderComponent: FunctionComponent<unknown> = () => (
  <Provider store={store}>
    <HowToGuides />
  </Provider>
);

export default ProviderComponent;
